<template lang="pug">
.container
  img.banner(src='@/assets/imgs/banner.png')
  .compare-btn
    span.compare-btn-left(@click="activeIndexChange(0)" :class="{'selected': activeIndex == 0}") 特权对比
    span.compare-btn-right(@click="activeIndexChange(1)" :class="{'selected': activeIndex == 1}") 特权分类
  comparison(v-if='activeIndex === 0' @goBuy="goBuy")
  classify(v-if='activeIndex === 1')
  buyVip(@closeVip='closeVip' v-if='showBuyVip' @goBuy="goBuy")
  .vip-list-container(v-if='showMore')
    .content
      morePackage(@closeMorePackage='showMore = false')
  DictWebsiteFooter(theme="gray")
  VipCenter(:debug="AppMode" :isShow="isShowVipCenter" @closeVipCenter="isShowVipCenter = false" :routeQuery="$route.query")
</template>

<script>
import buyVip from '@/components/buyVip.vue';
import classify from '@/components/classify.vue';
import comparison from '@/components/comparison.vue';
import morePackage from '@/components/morePackage.vue';

export default {
  name: 'Compare',
  components: {
    buyVip,
    comparison,
    classify,
    morePackage,
  },
  mounted() {
    if (this.$route.hash !== '') {
      this.activeIndex = 1;
    }
  },
  watch: {
    '$route.query.buyVip': {
      handler(val) {
        if (val === 'true') {
          this.goBuy();
        }
      },
      immediate: true,
    },
    '$route.query.buyMore': {
      handler(val) {
        if (val === 'true') {
          this.showMore = true;
        }
      },
      immediate: true,
    },
    showBuyVip: {
      handler(val) {
        if (val) {
          this.stopMove();
        } else {
          this.Move();
        }
      },
    },
    showMore: {
      handler(val) {
        if (val) {
          this.stopMove();
        } else {
          this.Move();
        }
      },
    },
  },
  data() {
    return {
      activeIndex: 0, // 0特权对比，1特权分类
      showBuyVip: false,
      showMore: false,
      isShowVipCenter: false,
      AppMode: process.env.VUE_APP_MODE !== 'prod',
    };
  },
  methods: {
    closeVip() {
      this.showBuyVip = false;
    },
    goBuy() {
      // this.showBuyVip = true;
      this.isShowVipCenter = true;
    },
    activeIndexChange(idx) {
      this.activeIndex = idx;
      if (idx === 0) {
        this.$router.push({ path: '/privilege', query: { ...this.$route.query } });
      } else if (idx === 1) {
        this.$router.push({ path: '/privilege#0', query: { ...this.$route.query } });
      }
    },
    // 阻止页面滚动，针对非chrome浏览器
    stopMove() {
      const m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = 'hidden';
      document.addEventListener('touchmove', m, { passive: false }); // 禁止页面滑动
    },
    // 开启页面滚动
    Move() {
      const m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ''; // 出现滚动条
      document.removeEventListener('touchmove', m, { passive: true });
    },
  },
};
</script>

<style lang="stylus" scoped>
.container
  min-width 1320px
  .banner
    width 100%
  .compare-btn
    width 400px
    height 73px
    border-radius 72px
    background-color #F4F5F7
    margin 72px auto 0 auto
    .compare-btn-left
      display inline-block
      width 200px
      height 73px
      text-align center
      line-height 73px
      cursor pointer
      font-size 20px
      font-family: 'PingFang SC';
      font-style: normal;
      color: #626469;
    .compare-btn-right
      display inline-block
      line-height 73px
      width 200px
      text-align center
      cursor pointer
      font-size 20px
      font-family 'PingFang SC'
      font-style normal
      color #626469
    .selected
      border-radius 72px
      background-color #FCCDA2
      font-weight 500
      color #291702
      font-family 'PingFang-SC-SemiBlod'
  .content
    margin 0 auto
  .vip-list-container
    position fixed
    top 0
    right 0
    width 100%
    height 100%
    background rgba(9, 11, 15, 0.2)
    display flex
    justify-content center
    align-items center
    z-index 999
    .content
      width 700px
      height 492px
      border-radius 10px
      position relative
      .close
        position absolute
        right 25px
        top 7px
        width 20px
        cursor pointer
</style>
